import React from "react";
import { HiPlus } from "react-icons/hi"; // Plus icon

const CustomButton = ({ text, onClick }) => {
  return (
    <button
      onClick={onClick}
      aria-label={text}
      className="bg-brand-600 text-white px-4 py-2.5 rounded-xl font-medium shadow-sm flex items-center justify-center gap-2 hover:bg-brand-700 hover:shadow-md"
    >
      <span className="block lg:hidden">
        <HiPlus className="text-lg" />
      </span>
      <span className="hidden lg:block">{text}</span>
    </button>
  );
};

export default CustomButton;
